import * as fe from "@runn/filter-engine"
import React from "react"

import type {
  FilterComponentProps,
  FilterValues,
} from "~/common/SuperSearch/types"
import { PersonPin as Icon } from "~/common/react-icons"

import FilterBlockReadonly from "~/Views/FilterBlockReadonly"

import {
  FilterBlock,
  useAutoRemoveMissingListValues,
  useSelectedListOptions,
} from "./common"

const availableOptions = [
  {
    label: "No Request",
    value: "",
  },
  {
    label: "Request Raised",
    value: "REQUESTED",
  },
  {
    label: "Request Responded",
    value: "PENDING",
  },
  {
    label: "Hire Proposed",
    value: "NEED_TO_HIRE",
  },
]

type BaseProps = {
  filter: fe.filters.FilterPersonPlaceholderStatus
}

type Props = FilterComponentProps & BaseProps

const useValues = (props: BaseProps): FilterValues => {
  const { filter } = props

  const selectedOptions = useSelectedListOptions({
    filter,
    availableOptions,
  })

  return {
    name: "Resourcing Request Status",
    availableOptions,
    selectedOptions,
  }
}

const Component = (props: Props) => {
  const {
    filter,
    path,
    disabled,
    isDropdownOpen,
    onChange,
    onRemove,
    onChangeDropdownOpen,
  } = props

  const handleChange = (list: string[]) => {
    return onChange(path, fe.filters.personPlaceholderStatus({ list }))
  }

  const handleRemove = () => onRemove(path)

  const { selectedOptions, name } = useValues({
    filter,
  })

  useAutoRemoveMissingListValues({
    filter,
    selectedOptions,
    onChange: handleChange,
  })

  return (
    <FilterBlock
      icon={<Icon />}
      label={name}
      filterLabelPlural="statuses"
      isDropdownOpen={isDropdownOpen}
      selectedOptions={selectedOptions}
      availableOptions={availableOptions}
      onChange={handleChange}
      onChangeDropdownOpen={onChangeDropdownOpen}
      onRemove={handleRemove}
      disabled={disabled}
    />
  )
}

const ReadonlyComponent = (props: Props) => {
  const { filter } = props

  const { selectedOptions, name } = useValues({
    filter,
  })

  return <FilterBlockReadonly name={name} selectedOptions={selectedOptions} />
}

export const PersonPlaceholderStatus = {
  Component,
  ReadonlyComponent,
}
